import { Fragment, useRef } from 'react'

import { Dialog, Transition } from '@headlessui/react'

interface Props {
  open: boolean
  onClose: () => void | Promise<void>
  children: React.ReactNode
  className?: string
}

export const Modal = ({ open, onClose, children, className = '' }: Props) => {
  const cancelButtonRef = useRef(null)

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog as="div" className="relative !z-50" initialFocus={cancelButtonRef} onClose={onClose}>
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 !bg-[#00000050] bg-opacity-60 backdrop-blur-[2px] transition-opacity" />
        </Transition.Child>
        <div className="fixed inset-0 z-50 w-auto h-auto overflow-y-auto">
          <div className="absolute w-full h-full z-0" onClick={onClose} />
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <div className={className}>{children}</div>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  )
}
